// Configurazione DevExtreme - deve essere importato prima di qualsiasi componente DevExtreme
import config from "devextreme/core/config";
import { loadMessages, locale } from "devextreme/localization";
import * as messagesIt from "devextreme/localization/messages/it.json";

// Carica la licenza dalle variabili d'ambiente
const licenseDevextreme = import.meta.env.VITE_LICENSE_DEVEXTREME;

// Configura DevExtreme
loadMessages(messagesIt);
locale("it");
config({
  licenseKey: licenseDevextreme,
});

// Debug: verifica che la licenza sia caricata
